import { Button, Grid } from '@material-ui/core'
import { Stack } from '@mui/material'
import CustomTextField from 'components/Form/CustomTextField'
import ProgressButton from 'components/ProgressButton'
import { Form, Formik } from 'formik'
import React from 'react'
import { TemplateFormSchema } from 'schemas/setting'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import ErrorMessage from '../../../../components/ErrorMessage'

const toolbarOptions = [
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  ['bold', 'italic', 'underline', 'strike', 'link'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ color: [] }],
  ['clean']
]
export const modules = {
  toolbar: toolbarOptions
}

export const TemplateForm = ({ onCancel, onSubmit, isLoading, initialValues }) => {
  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={onSubmit}
      validationSchema={TemplateFormSchema}>
      {({ setFieldValue, values, errors, touched }) => (
        <Form>
          <Grid container item spacing={3}>
            <Grid item xs={12}>
              <CustomTextField label="Email Subject" name="subject" type="text" />
            </Grid>

            <Grid item xs={12}>
              <ReactQuill
                theme="snow"
                modules={modules}
                value={values.body}
                onChange={(value) => setFieldValue('body', value)}
                placeholder="Write your email body here..."
              />
              <ErrorMessage message={touched?.body && errors?.body} />
            </Grid>
          </Grid>

          <Stack direction="row" gap={2} justifyContent="end" mt={4} mb={1}>
            <Button onClick={onCancel} disabled={isLoading}>
              Cancel
            </Button>
            <Grid item>
              <ProgressButton
                type="submit"
                label="Save"
                variant="contained"
                color="primary"
                disabled={isLoading}
                inProgress={isLoading}
              />
            </Grid>
          </Stack>
        </Form>
      )}
    </Formik>
  )
}

export default TemplateForm
